'use client';

import Card from '@/components/Card/Card';
import { NewLine } from '@/components/Form/Fields';
import FormField from '@/components/Form/FormField';
import { isVisible } from '@/components/Form/helper/formHelper';
import type { FormValues } from '@/components/Form/types';
import type { FormSectionStoryblok, FormStoryblok } from '@/types/component-types-sb';
import { storyblokEditable } from '@storyblok/react/rsc';
import { type FC } from 'react';

interface FormSectionProps {
  sectionBlok: FormSectionStoryblok;
  index: number;
  formValues: FormValues;
  form: FormStoryblok;
}
const FormSection: FC<FormSectionProps> = ({ sectionBlok, index, formValues, form }: FormSectionProps) => {
  // Do not render if it is hidden
  if (!isVisible(sectionBlok, form, formValues)) {
    return null;
  }

  return (
    <Card
      className="fullWidth FormSection"
      key={sectionBlok._uid || `section-${index}`}
      variant="Box"
      {...storyblokEditable(sectionBlok)}
    >
      {sectionBlok.id && <h4 className={'font-label-bold'}>{sectionBlok.id}</h4>}
      <div className="formGrid">
        {sectionBlok.fields?.map((fieldBlok, fieldIndex) => {
          if (fieldBlok.component === 'NewLine') {
            return <NewLine key={fieldBlok._uid} />;
          }
          return (
            <FormField
              key={fieldBlok._uid || `field-${fieldIndex}`}
              fieldBlok={fieldBlok}
              index={fieldIndex}
              formValues={formValues}
              form={form}
            />
          );
        })}
      </div>
    </Card>
  );
};
export default FormSection;
